module.exports = __webpack_public_path__ + "static/media/ic_prestationMapHeader_calendar.92967658.svg";